/**
 * Maskerar de fyra sista siffrorna i ett personnummer, alltså födelsenummer, könssiffra och
 * kontrollsiffra. Födelsedatumet lämnas synligt eftersom det är det man känner igen personen på
 * i en lista, medan de fyra sista är det känsliga.
 *
 * Hanterar både 12 siffror och formatet med bindestreck. Ser värdet inte ut som ett personnummer
 * returneras det oförändrat, hellre det än att dölja något som visar sig vara en annan uppgift.
 */
export const maskPersonalIdentityNumber = (value?: string | null): string => {
  if (!value) return '';

  const digits = value.replace(/\D/g, '');

  if (digits.length !== 12 && digits.length !== 10) return value;

  return `${digits.slice(0, digits.length - 4)}-****`;
};
